import React, { useState } from 'react';
import PropTypes from 'prop-types';

import CouponSelector from '../../Upgrade/CouponSelector';
import { Plans } from '../../constants';
import './styles.scss';

const Coupons = ({ membership }) => {
  const suscriptionType = membership === Plans.SEASONAL ? 'Seasonal' : 'Annual';
  const suscriptionFee = membership === Plans.SEASONAL ? '49.99' : '179.99';
  const [couponsApplied] = useState([]);
  const [couponError, setCouponError] = useState({});

  const handleApplyCoupon = (code) => {
    if (code) {
      setCouponError({ message: 'This promo code is invalid', type: 'invalid' });
    } else {
      setCouponError({ message: 'The promo code is empty', type: 'empty' });
    }
  };

  return (
    <section className="coupons">
      <div className="coupon-divider" style={{ margin: '0 0 9px 0' }} />
      <div className="suscription-container">
        <div className="fee">
          <h4>{`${suscriptionType} Subscription`}</h4>
          <span>{suscriptionFee}</span>
        </div>
        <span className="coupons-text">1st Box - Summer Box</span>
      </div>
      <div className="coupon-divider" style={{ margin: '7px 0 11px 0' }} />
      <CouponSelector
        onApplyCoupon={handleApplyCoupon}
        error={couponError}
        couponsApplied={couponsApplied}
        isInitialyOpen={false}
      />
      <div className="shipping">
        <span className="coupons-text">Shipping*</span>
        <span className="coupons-highlight-text">2.00</span>
      </div>
      <div className="tax">
        <span className="coupons-text">Tax</span>
        <span className="coupons-highlight-text">0.00</span>
      </div>
      <div className="total">
        <span className="coupons-text">Total</span>
        <span className="coupons-highlight-text">
          {`${parseFloat(suscriptionFee) + 2} USD`}
        </span>
      </div>
    </section>
  );
};

Coupons.defaultProps = {
  membership: '',
};

Coupons.propTypes = {
  membership: PropTypes.string,
};

Coupons.displayName = 'Coupons';

export default Coupons;
